/* ==========================================================================
   OUTFIT BUILDER — a set in the cart (snippets/outfit-builder-cart-set)
   The quantity buttons and Remove change every piece of the set at once,
   then hand the new cart to the theme exactly like its own quantity box does
   (cart:change with the re-rendered sections; the cart page reloads).
   ========================================================================== */
(function () {
  'use strict';
  if (window.obCartSetReady) return;
  window.obCartSetReady = true;

  function root() { return document.documentElement; }

  async function setQuantity(card, quantity) {
    var keys = (card.getAttribute('data-ob-keys') || '').split(',').filter(Boolean);
    if (!keys.length) return;
    var updates = {};
    keys.forEach(function (key) { updates[key] = quantity; });

    card.setAttribute('aria-busy', 'true');
    card.querySelectorAll('[data-ob-cset-busy]').forEach(function (el) { el.setAttribute('aria-busy', 'true'); });
    root().dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    var sections = [];
    root().dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));

    var response;
    try {
      response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sections.join(',') })
      });
    } catch (e) {
      response = null;
    }
    root().dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    if (!response || !response.ok) {
      card.removeAttribute('aria-busy');
      card.querySelectorAll('[data-ob-cset-busy]').forEach(function (el) { el.removeAttribute('aria-busy'); });
      card.querySelectorAll('[data-ob-cset-input]').forEach(function (input) { input.value = card.getAttribute('data-ob-qty'); });
      return;
    }

    var cart = await response.json();
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
      window.location.reload();
      return;
    }
    root().dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'line-item:change', cart: cart }
    }));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ob-cset-step], [data-ob-cset-remove]');
    if (!button) return;
    var card = button.closest('[data-ob-cset]');
    if (!card || card.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();
    var current = parseInt(card.getAttribute('data-ob-qty'), 10) || 0;
    var next = button.hasAttribute('data-ob-cset-remove') ? 0 : Math.max(0, current + (parseInt(button.getAttribute('data-ob-cset-step'), 10) || 0));
    if (next !== current) setQuantity(card, next);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-ob-cset-input]');
    if (!input) return;
    var card = input.closest('[data-ob-cset]');
    if (!card) return;
    var next = Math.max(0, parseInt(input.value, 10) || 0);
    if (next !== (parseInt(card.getAttribute('data-ob-qty'), 10) || 0)) setQuantity(card, next);
  });
})();
